<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData[0],
           searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData[0] = $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment';

import JobForm from "../../../components/settings/job/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": JobForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
       search: this.$route.params.search,
      pageTitle: this.$t('setupjob.editjob'),
      pageTitleValue: "",
      formData: [],
      jobCatList: [],
      errMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      if (this.formData[0].isdisable == false) {
        this.formData[0].isdisable = 0;
      } else {
        this.formData[0].isdisable = 1;
      }

      var payload = this.formData[0];

      this.$store.dispatch('put', {url: "/job/" + vm.id, payload: payload})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "joblist", params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler($event) {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.isConfirm = !this.isConfirm;

      if ($event) {
        this.$store.dispatch('delete', {url:
              "/job/" +
              this.id +
              "/" +
              this.formData[0].userid})
          .then((res) => {
            if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: "joblist" });
            }
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
          });
      }
    },

    createHandler() {
      this.$router.push({ name: "jobnew" });
    },

    loadJobHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/job/" + vm.id})
        .then((res) => {
          if (res.status == 200) {
            vm.formData = res.data.rec;
            vm.pageTitleValue = vm.formData[0].jobtitle;

            // if (vm.formData[0].startdate) {
            //     vm.formData[0].startdate = moment(vm.formData[0].startdate).format('YYYY-MM-DD');
            // }

            // if (vm.formData[0].enddate) {
            //     vm.formData[0].enddate = moment(vm.formData[0].enddate).format('YYYY-MM-DD');
            // }

            if (vm.formData[0].isdisable === "N") {
              vm.formData[0].isdisable = false;
            } else {
              vm.formData[0].isdisable = true;
            }

            vm.formData[0].userid = vm.$store.getters.userId;

            vm.loading = false;
          } else {
            vm.isErr = !vm.isErr;
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    await this.loadJobHandler();
  },
};
</script>